// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"472":"settings","534":"deposits","668":"withdraws","685":"app-shell","809":"users","933":"auth","967":"wallets"}[chunkId] + "." + {"472":"1b6fc10f","534":"0c9fcf92","668":"724075a6","685":"69f28d55","809":"68feaa73","933":"291c0c06","967":"a3675a4a"}[chunkId] + ".js";
};